import * as React from "react";
import { ChevronDoubleLeft16Regular } from "@fluentui/react-icons";
import TableHeaderSection from "../tableHeader/TableHeader";
import IRepertoireComponentDataItem from "../../../../redux/types/IRepertoireComponentDataItem";
import { IRepertoireField } from "../../../types/IRepertoireField";
import ActionButton from "../../../../repertoire/components/actionButton/ActionButton";
import PaginationView from "../tablePagination/TablePagination";
import {
    ADJUSTMENT_MAINTENANCE_PAGE,
    DATE_FIELD,
    MESSAGE_VIEW,
    PRODUCT_SEARCH_MUSIC_DURATION_KEY,
    SELECT_ACTION,
    TITLE_STATE_KEY,
    USAGE_MATCHING_PRODUCTS_SECTION_KEY,
    USAGE_MATCHING_WORKS_SECTION_KEY
} from "../../../Consts";
import { addMatchWorkToUsage, addMatchProductToUsage, addWorkOrProductToUsageSearchCriteria, updateAdjustmentField, addMatchLicenseToUsage } from "../../../../redux/reducers/RepertoireReducer";

import { hideModal } from "../../../../redux/reducers/ModalReducer";
import { CopyTableContents } from "../../../services/TableFunctions";
import { convertSecondsToTimeStamp } from "../../../../util/tools";
import { SearchRequests } from "../../../services/SearchRequests";
import { CONFIGURATION_PARAMETER_FIELD_FORMAT_KEY, WORK_MAINTENANCE_GROUP } from "../../../ConfigurationConsts";
import { result } from "lodash";
import { DataSource } from "../../../types/DataSource";
import { WORK_NAME_LOOKUP } from "../../../../lookup/Consts";
import { getLookupValues } from "../../../../lookup/services/LookupHelpers";
import { ILookupDictionary } from "../../../../lookup/types/ILookupDictionary";
import { IWork } from "../../../types/IWork";
import { IAdjustmentDetails } from "../../../../redux/types/IAdjustmentDetails";
import { IDistribution } from "../../../types/usageTypes/IDistribution";
import { IDistributionSearchQuery } from "../../../types/usageTypes/IDistributionSearchQuery";
import { IAdjustmentState, IAdjustmentStateKeys } from "../../../../redux/types/IAdjustmentState";
import DateDisplay from "../../dateDisplay/DateDisplay";
import { RIGHT_ARROW_SVG } from "../../../IconConsts";
import { IIceDistCacheAdditionalInfoRequest } from "../../../types/IIceDistCacheAdditionalInfoRequest";
import { AllocationHeaderRowType } from "../../../types/usageTypes/IAllocationRowTypes";
import { IAdjustmentDetailsToSocietyAffiliation } from "../../../types/ISocietyAffiliation";

export interface IResultsTableProps {
    searchResultsTableData: IRepertoireComponentDataItem;
    tableContents: any;
    componentInstance: string;
    hideModal: typeof hideModal;
    indexOfFirstResult?: number;
    indexOfLastResult?: number;
    resultsPerPage?: number;
    currentPage?: number;
    updatePagination: (indexOfFirstResult: number, indexOfLastResult: number, resultsPerPage: number, currentPage: number, repertoireSection: string) => void;
    repertoireSection?: string;
    sourceItem?: any;
    onSelectResult?: (selectedResult: any) => void;
    addMatchworkToUsage?: typeof addMatchWorkToUsage;
    addMatchLicenseToUsage?: any;
    addMatchProductToUsage?: typeof addMatchProductToUsage;
    expandedResults?: number[];
    showModal?: (
        modalContent: string,
        modalComponentInstance: string,
        modalProps: any,
        displayModalCloseButton: boolean,
        title: string
    ) => void;
    expandAll?: boolean;
    expandResult?: (matchWorkResults: number) => void;
    expandAllResults?: () => void;
    sortSearchResults?: (name: string, results: any) => void;
    addWorkOrProductToUsageSearchCriteria?: typeof addWorkOrProductToUsageSearchCriteria;
    getWorkDetails?: (tableItem?: any, event?: React.MouseEvent) => void;
    getProductDetails?: (tableItem?: any, event?: React.MouseEvent, openInSecondTabDueToOrigin?: boolean) => void;
    updateAdjustmentDetail?: (value?: any, affiliations?: IAdjustmentDetailsToSocietyAffiliation[]) => void;
    adjustmentDetails?: IAdjustmentDetails[];
    adjustment?: IAdjustmentState;
    workAdjustmentIndex?: number;
    enabledAdjustmentICEWorkSearch?: boolean;
    allocationRecords?: AllocationHeaderRowType[];
    lookupValues?: ILookupDictionary;
}

interface IResultsTableState {
    tableContents: any;
    activeSortHeaderSection: string;
    currentPage: number;
    resultsPerPage: number;
    indexOfFirstResult: number;
    indexOfLastResult: number;
    isLoading?: boolean;
}

export default class ResultsTable extends React.PureComponent<
    IResultsTableProps,
    IResultsTableState
> {
    constructor(props: IResultsTableProps) {
        super(props);

        this.state = {
            tableContents: props.tableContents,
            activeSortHeaderSection: undefined,
            indexOfFirstResult: this.props.indexOfFirstResult ? this.props.indexOfFirstResult : 0,
            indexOfLastResult: this.props.indexOfLastResult ? this.props.indexOfLastResult : 10,
            resultsPerPage: this.props.resultsPerPage ? this.props.resultsPerPage : 10,
            currentPage: this.props.currentPage ? this.props.currentPage : 1,
            isLoading: false
        };
    }

    public ascending: boolean = false;

    componentDidUpdate = (prevProps: IResultsTableProps) => {
        const { tableContents } = this.props;

        if (prevProps.tableContents !== tableContents) {
            this.setState({ tableContents });
        }
    };

    sortTableByColumn = (section: string) => {
        const { componentInstance, sortSearchResults } = this.props;
        const { activeSortHeaderSection, tableContents } = this.state;
        const tableContentsCopy = CopyTableContents(tableContents);

        if (activeSortHeaderSection !== section) {
            this.ascending = false;
        }

        tableContentsCopy.sort((a: any, b: any) => {
            // set to emtpy string if null
            let newA = a[section] || "";
            let newB = b[section] || "";

            if (!this.ascending) {
                return newA.toString().localeCompare(newB.toString(), undefined, { 'numeric': true });
            }
            return newB.toString().localeCompare(newA.toString(), undefined, { 'numeric': true });

        });

        this.setState({
            tableContents: tableContentsCopy,
            activeSortHeaderSection: section
        });

        this.ascending = !this.ascending;

        if (sortSearchResults) {
            sortSearchResults(componentInstance, tableContentsCopy);
        }
    };

    onClickSelect = async (tableContentItem: any) => {
        const {
            onSelectResult,
            hideModal,
            addMatchworkToUsage,
            addMatchLicenseToUsage,
            addMatchProductToUsage,
            addWorkOrProductToUsageSearchCriteria,
            getWorkDetails,
            adjustmentDetails,
            updateAdjustmentDetail,
            workAdjustmentIndex,
            adjustment,
            enabledAdjustmentICEWorkSearch,
            allocationRecords
        } = this.props;
        
        if (onSelectResult) {
            onSelectResult({ ...tableContentItem });
            return;
        }

        if (addWorkOrProductToUsageSearchCriteria) {
            addWorkOrProductToUsageSearchCriteria({ ...tableContentItem });
            hideModal && hideModal();
        }
        else if (addMatchworkToUsage) {
            addMatchworkToUsage({ ...tableContentItem });
            hideModal && hideModal();
        }
        else if (addMatchLicenseToUsage) {
            addMatchLicenseToUsage({ ...tableContentItem });
            hideModal && hideModal();
        }
        else if (addMatchProductToUsage) {
            addMatchProductToUsage({ ...tableContentItem });
            hideModal();
        }
        else if (updateAdjustmentDetail) {
            const fetchData = async () => {
                this.setState({ isLoading: true })
                try {
                    // Step 1: Get Distributions
                    let searchQuery: IDistributionSearchQuery = {
                        year: '',
                        distributionType: '',
                        distributionStatus: '',
                        distributionCode: adjustmentDetails[workAdjustmentIndex ? workAdjustmentIndex : 0].adjustmentDetailFrom[0].distribution,
                        cat1: '',
                        cat2: '',
                        description: ''
                    };
                    let contributorsList = [];

                    const distributions = await SearchRequests.getDistributions(searchQuery);
                    const distributionDetails = await SearchRequests.getDistribution(distributions[0].distributionID);
                    const workResponse = await SearchRequests.getWork(DataSource.Repertoire, tableContentItem["workID"]);
                    if (enabledAdjustmentICEWorkSearch) {
                        const request: IIceDistCacheAdditionalInfoRequest = {
                            workID: tableContentItem["workID"],
                            adjustmentID: adjustment.id,
                            dataSource: DataSource.Repertoire,
                            sectionType: ADJUSTMENT_MAINTENANCE_PAGE.component,
                            allocatedUsageGroupIDs: allocationRecords.filter(x => x.IsSelected).map(x => x.UsageGroupID)
                        }
                        const distCacheAdditionalInfo = await SearchRequests.getIceDistCacheAdditionalInfo(request);
                        contributorsList = distCacheAdditionalInfo.workContributors;
                    } else {
                        contributorsList = workResponse.contributors.filter(item => (item.setType === 'repertoire' && item.setTypeGroup === distributionDetails.distributionSetTypeGroup));
                    }
                    adjustmentDetails[workAdjustmentIndex].adjustmentDetailTo = [];
                    const updatedAdjustmentDetails = [...adjustmentDetails];
                    if (contributorsList && contributorsList.length > 0) {
                        const workAffiliations: IAdjustmentDetailsToSocietyAffiliation[] = [];
                        const totalFromAmount = adjustmentDetails[workAdjustmentIndex].adjustmentDetailFrom.reduce((sum, row) => sum + Number(row.amountAdjusted || 0), 0);
                        const totalFromPoints = adjustmentDetails[workAdjustmentIndex].adjustmentDetailFrom.reduce((sum, row) => sum + Number(row.pointsAdjusted || 0), 0);
                        const totalFromShare = adjustmentDetails[workAdjustmentIndex].adjustmentDetailFrom.reduce((sum, row) => sum + Number(row.sharePercentAdjusted || 0), 0);

                        contributorsList.forEach((item, toRowIndex) => {
                            const newDetailShares = adjustmentDetails[workAdjustmentIndex].adjustmentDetailFrom.reduce((a, b) => { return Number(a) + Number(b.sharePercentAdjusted) }, 0);
                            const existingDetailShares = adjustmentDetails[workAdjustmentIndex].adjustmentDetailFrom.reduce((a, b) => { return Number(a) + Number(b.sharePercentAdjusted) }, 0);
                            const toSharePercentAdjusted = distributionDetails.distributionRightType === 'PER' ? ((Number(item.performingShare) / existingDetailShares) * newDetailShares) : ((Number(item.mechanicalShare) / existingDetailShares) * newDetailShares);
                            const toShareRatio = totalFromShare > 0 ? (toSharePercentAdjusted / totalFromShare) : 0;

                            adjustmentDetails[workAdjustmentIndex].adjustmentDetailTo.push({
                                adjustmentDetailID: 0,
                                adjustmentId: '',
                                allocationHeaderID: adjustmentDetails[workAdjustmentIndex ? workAdjustmentIndex : 0].adjustmentDetailFrom[0].allocationHeaderID,
                                distribution: this.props.adjustment.adjustmentDistribution,
                                pool: adjustment.adjustmentPool,
                                segment: adjustment.adjustmentSegment,
                                workNumber: workResponse.workNumbers[0]?.number,
                                workName: workResponse.workNames.filter(nameItem => nameItem.type === 'OT')[0].name,
                                usageGroupTitle: adjustmentDetails[workAdjustmentIndex].adjustmentDetailFrom[0]?.usageGroupTitle,
                                accountNumber: item.accountNumber,
                                name: item.fullName,
                                role: enabledAdjustmentICEWorkSearch ? item.type : item.role,
                                ipNumber: item.ipiNumber,
                                sharePercentAdjusted: toSharePercentAdjusted.toString(),
                                pointsAdjusted: (totalFromPoints * toShareRatio).toString(),
                                amountAdjusted: (totalFromAmount * toShareRatio).toString()
                            });

                            const societyAffiliation = distributionDetails.distributionRightType === 'PER'? item.perfSocietyAffiliation : distributionDetails.distributionRightType === 'MEC' ? item.mechSocietyAffiliation : undefined;
                            if (societyAffiliation !== undefined) {
                                workAffiliations.push({
                                    adjustmentDetailsId:
                                        adjustmentDetails[workAdjustmentIndex].id,
                                    toRowIndex,
                                    ipiNumber: item.ipiNumber,
                                    accountNumber: item.accountNumber,
                                    societyAffiliation: societyAffiliation ?? ""
                                });
                            }
                        });
                        updateAdjustmentDetail(updatedAdjustmentDetails, workAffiliations);
                    } else {
                        const { adjustment, adjustment: { adjustmentDetails } } = this.props;
                        let updatedAdjustmentDetails = adjustmentDetails;
                        let updatedAdjustmentDetail = updatedAdjustmentDetails[workAdjustmentIndex ? workAdjustmentIndex : 0];
                        updatedAdjustmentDetails[workAdjustmentIndex ? workAdjustmentIndex : 0].adjustmentDetailTo.push({
                            adjustmentDetailID: 0,
                            adjustmentId: adjustment.id,
                            allocationHeaderID: updatedAdjustmentDetail.id,
                            distribution: adjustment.adjustmentDistribution,
                            pool: adjustment.adjustmentPool,
                            segment: adjustment.adjustmentSegment,
                            workNumber: updatedAdjustmentDetail.adjustmentDetailFrom[0].workNumber,
                            workName: updatedAdjustmentDetail.adjustmentDetailFrom[0].workName,
                            usageGroupTitle: updatedAdjustmentDetail.adjustmentDetailFrom[0]?.usageGroupTitle,
                            accountNumber: '',
                            name: '',
                            role: '',
                            ipNumber: undefined,
                            sharePercentAdjusted: '',
                            pointsAdjusted: '',
                            amountAdjusted: ''
                        });
                        updateAdjustmentField(updatedAdjustmentDetails, 'adjustmentDetails');
                    }

                } catch (error: any) {
                    if (error.response.status === 404 || error.response.status === 409) {
                        this.props.showModal(MESSAGE_VIEW, null, { textToScreen: error.response.data }, true, "");
                    } else {
                        this.props.showModal(MESSAGE_VIEW, null, { textToScreen: "An issue occurred fetching work details" }, true, "");
                    }
                } finally {
                    this.setState({ isLoading: false })
                }
            };
            fetchData();
        };
    }
    renderExpandAll = () => {
        const { expandAll, expandAllResults, expandResult, componentInstance } = this.props;
        let expandText = '';
        let collapseText = ''
        if (componentInstance === USAGE_MATCHING_WORKS_SECTION_KEY) {
            expandText = 'Expand Search Results';
            collapseText = 'Collapse Search Results'
        } else {
            expandText = 'Expand Results'
            collapseText = 'Collapse Results'
        }
        return (expandResult ?
            <div className='arrowIconExpandDiv'>
                <div className={expandAll ? "arrowIconExpandAllExpanded" : "arrowIconExpandAll"}>
                    <ChevronDoubleLeft16Regular className="icon" aria-hidden="true" id="expandResultsButton" onClick={() => expandAllResults()} title={expandAll ? "Collapse Results" : "Expand Results"} />
                </div>
                {expandAll ? <div className='arrowIconExpandText'> {collapseText}</div> : <div className='arrowIconExpandText'> {expandText}</div>}
            </div> : <div></div>
        );
    }

    renderPaginationView(): JSX.Element {
        const { repertoireSection } = this.props;
        const { tableContents, resultsPerPage, currentPage } = this.state;
        return <PaginationView
            contentsLength={tableContents ? tableContents.length : 0}
            resultsPerPage={resultsPerPage}
            currentPage={currentPage}
            updateContentsTable={this.updateContentsTable.bind(this)}
            repertoireSection={repertoireSection}
        />
    }

    updateContentsTable(indexOfFirstResult: number, indexOfLastResult: number, resultsPerPage: number, currentPage: number, repertoireSection: string): void {
        this.setState({ indexOfFirstResult, indexOfLastResult, resultsPerPage, currentPage });
        this.props.updatePagination(indexOfFirstResult, indexOfLastResult, resultsPerPage, currentPage, repertoireSection);
    }

    renderHeaderSections = () => {
        const { searchResultsTableData, componentInstance } = this.props;
        const { activeSortHeaderSection } = this.state;

        if (searchResultsTableData && searchResultsTableData.fields) {
            const filteredFields = searchResultsTableData.fields.filter(
                (field: IRepertoireField) =>
                    field.componentInstance === componentInstance
            );

            return filteredFields.map((section: IRepertoireField, index: number) => (
                <td key={index} className="td">
                    <TableHeaderSection
                        section={section.data}
                        fieldName={section.name}
                        isSortingActive={section.name === activeSortHeaderSection}
                        ascending={this.ascending}
                        onClickHeaderSection={this.sortTableByColumn}
                        sortable
                    />
                </td>
            ));
        }
    };

    excludeObjectKeys = (key: string) => {
        const excludedKeys = ['compoundType'];

        if (excludedKeys.includes(key)) {
            return true;
        } else {
            return false;
        }
    }

    isTitleKey = (key?: string) => {
        return key === TITLE_STATE_KEY || key === "titles";
    }

    formatWorkTitleWithTypeCode = (title: string, typeCode?: string) => {
        if (!title || !typeCode) {
            return title;
        }
        return `${title} (${typeCode})`;
    }
    onClickExternalIcon = (value, event?) => {
        const { getWorkDetails, getProductDetails, componentInstance } = this.props;

        switch (componentInstance) {
            case USAGE_MATCHING_WORKS_SECTION_KEY:
                getWorkDetails?.(value, event);
                break;

            case USAGE_MATCHING_PRODUCTS_SECTION_KEY:
                getProductDetails?.(value, event, true);
                break;

            default:
                break;
        }
    };

    renderMultipleTitlesDiv = (array: string[], objectKey?: string, currentResults?: any, searchResultIndex?: number) => {
        const isTitleKey = this.isTitleKey(objectKey);
        const list = Array.isArray(array) ? array : [array ?? ""];

        return (
            <div className="multipleTitlesDiv" style={{ wordBreak: "break-word", whiteSpace: "normal" }}>
                {list.map((item, index) => (
                    <React.Fragment key={index}>
                        {isTitleKey && item ? (
                            <div>
                                <a onClick={() => this.onClickExternalIcon(currentResults?.[searchResultIndex])}>
                                    {item}
                                    {index < list.length - 1 && ","}
                                </a>
                                <br />
                            </div>
                        ) : (
                            <div style={{ wordBreak: "break-word", whiteSpace: "normal" }}>
                                {item}
                                {index < list.length - 1 && ","}
                                <br />
                            </div>
                        )}
                    </React.Fragment>
                ))}
            </div>
        );
    };

    renderSearchResults = () => {
        const { tableContents, indexOfFirstResult, indexOfLastResult } = this.state;
        const { searchResultsTableData, componentInstance, expandedResults, expandResult, lookupValues } = this.props;
        const currentResults = tableContents.slice(
            indexOfFirstResult,
            indexOfLastResult
        );
        const isUsageMatchingWorks = componentInstance === USAGE_MATCHING_WORKS_SECTION_KEY;
        const workNameLookups = lookupValues ? getLookupValues(WORK_NAME_LOOKUP, lookupValues) : [];
        const resolveTitleTypeCode = (typeCode?: string) => {
            const typeId = Number(typeCode);
            const matchedLookup = workNameLookups.find((lookup) => lookup.typeID === typeId);
            if (matchedLookup?.code) {
                return matchedLookup.code;
            }
        };

        let filteredFields = searchResultsTableData.fields.filter(
            (field: IRepertoireField) =>
                field.componentInstance === componentInstance
        );
        return currentResults.map(
            (tableContentItem: any, index: number) => {
                const sections: JSX.Element[] = [];

                filteredFields.map((field, x: number) => {
                    if (field.fieldType === SELECT_ACTION) {
                        sections.push(
                            <td key={`${index}.${x}`} className="td" title={field.data}>
                                <ActionButton
                                    buttonText={field.data}
                                    buttonAction={() => this.onClickSelect(tableContentItem)}
                                />
                            </td>
                        );
                    } else if (field.fieldType === DATE_FIELD) {
                        let item = tableContentItem[field.name];
                        sections.push(
                            <td key={`${index}.${x}`} className="td" title={field.data}>
                                {item ? <DateDisplay value={item} /> : ''}
                            </td>
                        );

                    }
                    else {
                        let item;

                        if (!this.excludeObjectKeys(field.name) && componentInstance !== USAGE_MATCHING_WORKS_SECTION_KEY) {
                            if (componentInstance === USAGE_MATCHING_PRODUCTS_SECTION_KEY && field.name === PRODUCT_SEARCH_MUSIC_DURATION_KEY) {
                                item = tableContentItem[field.name][0] ? convertSecondsToTimeStamp(tableContentItem[field.name][0]) : '';
                            } else {
                                item = tableContentItem[field.name];
                            }
                        }
                        else {
                            item = tableContentItem?.[field.name] && tableContentItem?.[field.name]?.[0] ? tableContentItem[field.name][0] : '';
                        }

                        const fieldValue = tableContentItem[field.name];
                        const isTitleField = this.isTitleKey(field.name);
                        const titleTypeCodes = Array.isArray(tableContentItem?.titleTypeCodes) ? tableContentItem.titleTypeCodes : [];
                        const formattedTitleValues = isUsageMatchingWorks && isTitleField
                            ? (Array.isArray(fieldValue) ? fieldValue : fieldValue ? [fieldValue] : []).map((title, titleIndex) =>
                                this.formatWorkTitleWithTypeCode(title, resolveTitleTypeCode(titleTypeCodes[titleIndex]))
                              )
                            : undefined;
                        const hasMultipleValues =
                            !this.excludeObjectKeys(field.name) &&
                            Array.isArray(fieldValue) &&
                            fieldValue.length > 1;
                        const hasMultipleFormattedValues = formattedTitleValues ? formattedTitleValues.length > 1 : hasMultipleValues;
                        const displayValue = formattedTitleValues ? formattedTitleValues[0] ?? "" : item;

                        sections.push(
                            <>
                                <td key={`${index}.${x}`} className="td" title={
                                    field.name in tableContentItem && tableContentItem[field.name] ? tableContentItem[field.name][0] : field.data}>
                                    <div className="arrowIconDiv">
                                        {(this.isTitleKey(field.name)) && (
                                            <img
                                                src={RIGHT_ARROW_SVG}
                                                title="Expand title"
                                                alt="Right Arrow icon"
                                                className={(expandedResults && expandedResults.includes(index)) ? "arrowIconExpanded" : "arrowIcon"}
                                                onClick={() => expandResult(index)}
                                            />
                                        )}
                                        {expandedResults &&
                                            expandedResults.includes(index) &&
                                            hasMultipleFormattedValues ? (
                                            this.renderMultipleTitlesDiv(formattedTitleValues ?? fieldValue, field.name, currentResults, index)
                                        ) : (
                                            <div className="workTitle">
                                                {this.isTitleKey(field.name) &&
                                                    displayValue &&
                                                     (componentInstance === USAGE_MATCHING_WORKS_SECTION_KEY || componentInstance === USAGE_MATCHING_PRODUCTS_SECTION_KEY) ? (
                                                    <a onClick={(event) => this.onClickExternalIcon(currentResults[index], event)}>
                                                        {displayValue}
                                                    </a>
                                                ) : displayValue === "" &&
                                                    this.isTitleKey(field.name) &&
                                                    (componentInstance === USAGE_MATCHING_WORKS_SECTION_KEY  || componentInstance === USAGE_MATCHING_PRODUCTS_SECTION_KEY) ? (
                                                    "Title not available"
                                                ) : (
                                                    displayValue ?? ""
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </td>
                            </>)
                    }
                });

                return (
                    <tr
                        key={index}
                        className="trSelectable"
                        onClick={() => null}
                    >
                        {sections}
                    </tr>
                );
            }
        );
    };

    renderSelectionTable = () => {
        return (
            <div className="selectionTable">
                {this.renderExpandAll()}
                <div className="tableContainer">
                    <table className="table">
                        <thead className="thead">
                            <tr className="tr">{this.renderHeaderSections()}</tr>
                        </thead>
                        <tbody className="tbody">{this.renderSearchResults()}</tbody>
                    </table>
                </div>
                {this.renderPaginationView()}
            </div>
        );
    };

    render() {
        const { isLoading } = this.state;
        if (isLoading) {
            return (
                <div>
                    <div className="loaderWrapper">
                        <div className="spinner-dualball">
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                    </div>
                    {this.renderSelectionTable()}
                </div>
            )
        } else {
            return (
                <div>
                    {this.renderSelectionTable()}
                </div>
            )
        }

    }
}

